import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Filial response body */
export interface FilialFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /** Color (for interfaces) */
  color: string;
  /** Soft deletion flag */
  deleted: boolean;
  /** Related rooms */
  rooms?: RoomFindInterface[];
}

/** Filial response body - DTO schema */
export const FilialFindDto = SerdeDtoClass.create<FilialFindInterface>(CatalogDtosKeysEnum.FILIAL_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Удален',
    serializer: yup.boolean(),
  },
  rooms: {
    optional: true,
    label: 'Помещения',
    nested: CatalogDtosKeysEnum.ROOM_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
